import { AutogenLayoutCarrierStatus } from "./autogen/AutogenLayoutCarrierStatus";
import { DuplicateId } from "./DuplicateId";

export class CarrierStatus extends AutogenLayoutCarrierStatus {

    onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "carrier_status",
            screenName: "Carrier Status",
            navigateToUrl: "lme/dispatch/CarrierStatusList",
            listLayout: true
        });
    }
}
